import { render, staticRenderFns } from "./BusinessPlanQuickTour.vue?vue&type=template&id=7adc5d7e"
import script from "./BusinessPlanQuickTour.vue?vue&type=script&lang=js"
export * from "./BusinessPlanQuickTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7adc5d7e')) {
      api.createRecord('7adc5d7e', component.options)
    } else {
      api.reload('7adc5d7e', component.options)
    }
    module.hot.accept("./BusinessPlanQuickTour.vue?vue&type=template&id=7adc5d7e", function () {
      api.rerender('7adc5d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/Components/QuickTours/BusinessPlanQuickTour.vue"
export default component.exports